export const useMeshHover = (refMesh, onHover, onUnhover) => {
  const { camera, raycaster, renderer, sizes } = useTresContext()
  const { onLoop } = useRenderLoop()

  const hovering = ref(false)
  const pointer = new Vector2()

  const _onPointerMove = (evt) => {
    pointer.x = (evt.clientX / sizes.width.value) * 2 - 1
    pointer.y = -(evt.clientY / sizes.height.value) * 2 + 1
  }
  onMounted(() => {
    document.body.addEventListener("pointermove", _onPointerMove)
  })
  onUnmounted(() => {
    document.body.removeEventListener("pointermove", _onPointerMove)
  })

  onLoop(() => {
    raycaster.value.setFromCamera(pointer, camera.value)

    if (!refMesh.value) return
    const intersects = raycaster.value.intersectObjects([refMesh.value], true)

    const wasHover = hovering.value
    hovering.value = intersects.length > 0
    if (wasHover !== hovering.value) {
      if (hovering.value) {
        onHover?.(intersects)
      } else {
        onUnhover?.(intersects)
      }
    }
  })

  return hovering
}
